import { Facebook } from "lucide-react";
import { useContent } from "@/content/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const f = content.footer;

  return (
    <footer className="relative border-t border-[rgba(212,175,55,0.18)] bg-[#070708] pt-20 pb-10 overflow-hidden" data-testid="main-footer">
      <div aria-hidden="true" className="absolute left-1/2 -translate-x-1/2 top-0 w-[60vw] h-[30vh] gold-glow-radial pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <blockquote className="max-w-4xl mx-auto text-center">
          <p className="font-serif-lux italic text-2xl sm:text-3xl lg:text-4xl text-[#E8E8EC] leading-snug tracking-tight" data-testid="footer-quote">
            “{f.quotePre}<span className="text-gold-champagne">{f.quoteAccent}</span>{f.quotePost}”
          </p>
          <cite className="mt-6 block font-mono-lux text-xs tracking-[0.3em] text-gold not-italic">{f.quoteBy}</cite>
        </blockquote>

        <div className="gold-rule-h my-12" aria-hidden="true" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <span className="w-8 h-8 border border-[rgba(212,175,55,0.5)] flex items-center justify-center font-serif-lux text-gold">
              {(content.nav.brand || "S").charAt(0)}
            </span>
            <div className="leading-tight">
              <p className="font-serif-lux text-base text-[#F7F7F8] tracking-wide">{content.nav.brand}</p>
              <p className="font-mono-lux text-[9px] tracking-[0.3em] text-[#757582]">ENTREPRENEUR · LEADER · BUILDER · MENTOR</p>
            </div>
          </div>

          <a
            href={f.fbUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-ecentra-link"
            className="inline-flex items-center gap-2.5 border border-[rgba(212,175,55,0.3)] px-5 py-2.5 text-sm text-gold-champagne hover:bg-[rgba(212,175,55,0.08)] hover:border-[rgba(243,227,166,0.6)] transition-colors duration-300"
          >
            <Facebook size={16} />
            {f.fbLabel}
          </a>
        </div>

        <p className="mt-10 text-center text-xs text-[#55555f]" data-testid="footer-copyright">
          {f.copyright}{" "}
          <a href="/admin" className="text-[#3f3f47] hover:text-gold transition-colors" data-testid="footer-admin-link">Admin</a>
        </p>
      </div>
    </footer>
  );
}
